export interface NamecheckResult {
  ok: boolean;
  field?: 'firstName' | 'lastName';
}

/**
 * POSTs first/last name to the PHP namecheck endpoint.
 * Per spec: fail OPEN. If the request errors (network, 5xx), resolve { ok: true }
 * so backend hiccups don't strand the user mid-flow.
 */
export async function checkNames(firstName: string, lastName: string): Promise<NamecheckResult> {
  try {
    const res = await fetch('/api/namecheck.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ firstName, lastName }),
    });
    if (!res.ok) {
      console.warn('namecheck endpoint returned', res.status);
      return { ok: true };
    }
    const data = (await res.json()) as NamecheckResult;
    return data;
  } catch (err) {
    console.warn('namecheck endpoint error, failing open', err);
    return { ok: true };
  }
}
